import 'canvg'